import React, { memo } from 'react';
import { ApiPagingResponseData } from '@remodeling/base';
import { ConstructionCaseContent } from '@remodeling/content';
import ConstructionCase from './Construction';
import Consultant from './Consultant';
import EnterShops from './EnterShop';
import IntroContent from './IntroContent';
import Preview from './Preview';
import { ExhibitHallViewInfo } from '@/types';

interface StoreTabProps {
  tabName: string;
  data?: ExhibitHallViewInfo;
  handleLinkOpen: (value: string) => void;
  constructData?: ApiPagingResponseData<ConstructionCaseContent>;
  handleConstructionPopup: () => void;
}

const StoreTab = ({
  data,
  tabName,
  constructData,
  handleConstructionPopup,
  handleLinkOpen,
}: StoreTabProps) => {
  return (
    <>
      <IntroContent data={data} />
      {!!data?.images && data?.images.length > 0 && (
        <Preview
          title={`${tabName} 미리보기`}
          data={data?.images}
          gtmValue={{
            'tab-value': tabName,
          }}
        />
      )}
      {!!data?.enterShops && data?.enterShops.length > 0 && (
        <EnterShops
          title={`${tabName}  입점 대리점`}
          handleLinkOpen={handleLinkOpen}
          data={data?.enterShops}
          gtmValue={{
            'tab-value': tabName,
          }}
        />
      )}
      {/* 시공사례 */}
      {!!constructData && constructData.totalElements > 0 && (
        <ConstructionCase
          constructData={constructData}
          type={tabName}
          handleConstructionPopup={handleConstructionPopup}
          gtmValue={{
            'tab-value': tabName,
          }}
        />
      )}

      {!!data?.consultants &&
        data?.consultants.length > 0 &&
        data?.consultantShowYn === 'Y' && (
          <Consultant
            title={`${tabName}  전문 상담사`}
            data={data?.consultants}
            gtmValue={{
              'tab-value': tabName,
            }}
          />
        )}
    </>
  );
};

export default memo(StoreTab);
